<template>
  <div>
    <v-card
      v-for="item in items"
      :key="item.key"
      class="mb-4"
    >
      <div class="d-flex flex-no-wrap justify-space-between align-center">
        <div>
          <v-card-title > <div v-html="item.title" /></v-card-title>
          <v-card-text>
            <div v-html="item.text" />
          </v-card-text>
        </div>
        <v-avatar v-if="item.status === 'success'" color="success" class="mr-6">
          <v-icon v-if="!item.score" dark>mdi-numeric-positive-1</v-icon>
          <div v-else style="color: white; font-weight: 700">{{item.score}}</div>
        </v-avatar>
        <v-avatar v-else-if="item.status === 'temporary'" color="grey" class="mr-6">
          <div style="color: white; font-weight: 700">?</div>
        </v-avatar>
        <v-avatar v-else-if="item.status === 'partial'" color="warning" class="mr-6">
          <div style="color: white; font-weight: 700">{{item.score}}</div>
        </v-avatar>
        <v-avatar v-else color="error" class="mr-6">
          <v-icon v-if="!item.score" dark>mdi-numeric-0</v-icon>
          <div v-else style="color: white; font-weight: 700">{{item.score}}</div>
        </v-avatar>
      </div>

      <v-list color="grey lighten-3">
        <v-subheader class="bottom-title">{{item.bottomTitle}}</v-subheader>
        <v-subheader v-if="item.bottomSubTitle">{{item.bottomSubTitle}}</v-subheader>
        <v-list-item
          v-for="subItem in item.subItems"
          :key="subItem.key"
          :color="subItem.success ? 'success' : 'error'"
          :input-value="true"
        >
          <v-list-item-icon>
            <v-icon v-if="subItem.success">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
          </v-list-item-icon>
          <v-list-item-title><div v-html="subItem.title" /></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'BaseCardList',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom-title {
  line-height: 15px;
  font-weight: 600;
}
</style>
